export default __webpack_public_path__ + "static/media/keeper_app.de89505d.png";